'use client';

import dynamic from 'next/dynamic';
import { AuthLoadingCard } from '@/components/app-loading-state';

interface LoginShellProps {
  resetSuccess: boolean;
  reason?: string;
  /** F12: validated `?next=` from the original requested URL, threaded through to the form. */
  nextPath?: string;
  initialMfa?: boolean;
}

const LoginContent = dynamic(
  () => import('./login-content').then((mod) => ({ default: mod.LoginContent })),
  {
    ssr: false,
    loading: () => <AuthLoadingCard />,
  },
);

/**
 * Client-only wrapper around `LoginContent`.
 *
 * Browser extensions (Apollo DevTools, Grammarly, 1Password, Dark Reader, etc.)
 * inject DOM into the login page during the SSR-to-hydration handoff, which
 * triggers React error #418 (hydration mismatch) and breaks the form before the
 * user can sign in. Rendering this shell client-only sidesteps the entire
 * hydration comparison — the server ships a small loading spinner; the actual
 * form is constructed in the browser after hydration completes, so any
 * extension-injected nodes are present from the start of React's reconciler
 * and never compared against pristine server output.
 *
 * Trade-off: ~50–100 ms flash of the spinner before the form appears.
 * Worth it: this is the surface where users hit the platform cold in their
 * normal Chrome with all extensions enabled, so reliability > paint speed.
 */
export function LoginShell(props: LoginShellProps) {
  return <LoginContent {...props} />;
}
